import { StrictMode, useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { router } from './router';
import { theme } from './theme';
import { Displays, DisplaysValues } from './type';
import { useWindowDimensions } from './hooks/useWindowDimensions';
import { DisplayModeContext } from './context/DisplayModeContext';

const App = () => {
  const { width, height } = useWindowDimensions();

  const displayMode: DisplaysValues = useMemo(() => {
    return width / height > 0.8 ? Displays.LANDSCAPE : Displays.PORTRAIT;
  }, [width, height]);

  const currentTheme = useMemo(() => {
    return {
      ...theme,
      unit: Displays.LANDSCAPE === displayMode ? 'vmin' : 'vmax',
    };
  }, [displayMode]);

  return (
    <StrictMode>
      <DisplayModeContext.Provider value={{ displayMode }}>
        <ThemeProvider theme={currentTheme}>
          <RouterProvider router={router} />
        </ThemeProvider>
      </DisplayModeContext.Provider>
    </StrictMode>
  );
};

export default App;
